// Aréna utility függvények - exact seat positions modell

export const SEAT_SIZE = 12.7;

// Szék azonosító: "R3-S15" formátum (row, seat number) - egyedi szektoron belül
export const seatKey = (r, s) => `R${r}-S${s}`;
export const fullSeatKey = (sectorId, r, s) => `${sectorId}-${seatKey(r, s)}`;

// Összes szék száma
export const totalSeats = (sectors) =>
  sectors.reduce((acc, s) => acc + (s.seats?.length || 0), 0);

// Eltávolított szék számláló adott szektorhoz
export const removedInSector = (removedSeats, sectorId) =>
  (removedSeats[sectorId] || []).length;

// Sor összes széke kivéve-e?
export const isRowFullyRemoved = (removedSeats, sector, rowNum) => {
  const removed = new Set(removedSeats[sector.id] || []);
  const rowSeats = (sector.seats || []).filter((seat) => seat.r === rowNum);
  if (rowSeats.length === 0) return false;
  return rowSeats.every((seat) => removed.has(seatKey(seat.r, seat.s)));
};

// Egy szék középpontja téglalapba esik-e
export const seatCenterInRect = (seat, rect) => {
  const cx = seat.x + SEAT_SIZE / 2;
  const cy = seat.y + SEAT_SIZE / 2;
  return cx >= rect.x1 && cx <= rect.x2 && cy >= rect.y1 && cy <= rect.y2;
};

// Pont egy szektor bbox-ban van-e
export const pointInSectorBbox = (px, py, sector) => {
  const b = sector.bbox;
  if (!b) return false;
  return px >= b.x && px <= b.x + b.width && py >= b.y && py <= b.y + b.height;
};

// Flex zóna számítás
export const flexZonePeople = (zone) =>
  Math.floor((zone.widthM || 0) * (zone.heightM || 0) * (zone.peoplePerSqm || 4));

// Total kapacitás (elérhető székek + flex emberek)
export const totalCapacity = (sectors, removedSeats, flexZones) => {
  const seatTotal = totalSeats(sectors);
  const removedTotal = sectors.reduce(
    (acc, s) => acc + removedInSector(removedSeats, s.id),
    0
  );
  const flexTotal = (flexZones || []).reduce((acc, z) => acc + flexZonePeople(z), 0);
  return {
    totalSeats: seatTotal,
    removedSeats: removedTotal,
    availableSeats: seatTotal - removedTotal,
    flexPeople: flexTotal,
    grandTotal: seatTotal - removedTotal + flexTotal,
  };
};

// Sektor elérhető szék száma
export const sectorAvailable = (sector, removedSeats) => {
  const total = sector.seats?.length || 0;
  const removed = removedInSector(removedSeats, sector.id);
  return { total, removed, available: total - removed };
};
